import React from 'react'
import LocationIcon from '../MenuImages/Marker.png';
import PhoneIcon from '../MenuImages/Phone.png';
import Card from '@mui/material/Card';

import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import '../../fonts/font.css'
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import SearchIcon from '../../images/NavBarImages/Search_100px.png';
import ForwardIcon from '../../images/NavBarImages/Forward_100px.png';
import OfferIcon from '../../images/NavBarImages/offericon192.png';
import chatIcon from '../../images/NavBarImages/chatgrayicon.png';
const ResturantInfoPanel = ({ RestInformation, handleCardClick, selectedCardIndex, DBDepartment, LanguageID, ShowSearch, SelectedType, ShowDetails, SelectedDepartment, SelectedGroupName, BranchInformationStatus }) => {
  return (


    <div style={{ textAlign: LanguageID === 2 ? 'start' : 'end', margin: '1.5vw' }}>



      <div className='row' style={{ display: 'flex' }}>

        {BranchInformationStatus === 'branch' && (

          <button className='col' onClick={() => ShowSearch('SearchPanel')} style={{ border: 'none', background: 'none', }} type="button">    <img style={{ width: '40px', height: '40px' }} src={SearchIcon} /> </button>
        )}


      </div>


      {(SelectedType != 'Item' && SelectedType !== 'Cart' && SelectedType !== 'Continue' && DBDepartment.length > 1) && (


        <div style={{
          display: 'flex',
          height: '20%',
          direction: LanguageID === 2 ? 'ltr' : 'rtl',

          overflowX: 'auto'
        }}>

          {DBDepartment.map((item, index) =>

            <Card className={`card ${selectedCardIndex === index ? 'selected' : ''}`}
              sx={{ marginRight: '5px', marginBottom: '5px' }}
              onClick={() => handleCardClick(index, item.did)}
              key={index}
              style={{
                minWidth: '75px', backgroundColor: selectedCardIndex === index ? '#2F3133' : 'white',
                color: selectedCardIndex === index ? 'white' : '#2F3133' // Change 'red' to the desired text color
              }}
            >

              <CardActionArea>




                <Typography style={{ fontFamily: 'basheer', fontSize: '12pt', paddingTop: '5px', paddingRight: '5px', paddingLeft: '5px', textAlign: 'center' }} gutterBottom variant="h5" component="div">
                  {item.departName}
                </Typography>





              </CardActionArea>
            </Card>


          )}



        </div>
      )}








    </div>


  )
}


export default ResturantInfoPanel